export const isIframe = (): boolean => {
  return window !== window.parent;
};
